namespace TabAurous.Retail {
    export namespace POSOrderItemsForInvoiceService {
        export const baseUrl = 'Retail/POSOrderItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSOrderItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSOrderItemsForInvoiceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
